export const ContentBoxStyle = {
  mt: 2,
  // p: 2,
  // boxShadow: "0 3px 3px rgba(0, 0, 0, 0.1)",
  width: "100%",
  height: "100%",
  // bgColor: "#F9FAFB",
};

export const ServerModalStyle = {
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  height: "800px",
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  userSelect: "none",
};

// plot colors
export const COLORS = [
  "red",
  "blue",
  "green",
  "orange",
  "purple",
  "pink",
  "gray",
  "brown",
  "cyan",
];

export const ContainedButtonStyles = {
  color: "var(--button-text-color)",
  backgroundColor: "var(--button-color)",
  borderRadius: "8px",
  transition: "background-color 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: "var(--button-hover-color)",
  },
};

export const OutlinedButtonStyles = {
  color: "#3b82f6",
  backgroundColor: "#ffffff",
  border: "1px solid #3b82f6",
  borderRadius: "8px",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: "#e0f2fe",
    borderColor: "#60a5fa",
    color: "#1d4ed8",
  },
};
